import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./InfoComponent.module.css";
import { useTranslation } from "@i18n";
import Input from "@/components/UiKit/Input/Input";
import { useEffect, useState, useRef } from "react";
import Select from "@/components/UiKit/Select/Select";
import { api__getCitiesDropDown } from "@/apis/assets/api__get_cities_drop_down";
import { CDN_LINK } from "@globalConfig";
import ChangeAccountVerificationModal from "@/_MiniApps/auth/ui/ChangeAccountVerificationModal/ChangeAccountVerificationModal";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useApi from "@hooks/useApi";
import Loader from "@componentsShared/Loader/Loader";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
import { useTamaraFinance } from "@/common/Contexts/TamaraFinanceContext";
import { api__createTamaraCheckoutSession, TamaraValidationError, OrderPaidError, PostReservedError } from "@/apis/tamara/tamara";
import { toast } from "sonner";
import { trackEvents } from "@/common/events/events";
import { serverUrl } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import { ValidationException } from "@/common/exceptions/ValidationException";
import useIsMobile from "@hooks/useIsMobile";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { useLang } from "@/common/Contexts/LanguageContext";
// Helper function to safely extract names from user object
var extractUserNames = function extractUserNames(user) {
  if (!(user !== null && user !== void 0 && user.full_name)) return {
    first_name: "",
    family_name: ""
  };
  var nameParts = user.full_name.trim().split(" ");
  var first_name = nameParts[0] || "";
  var family_name = nameParts.slice(1).join(" ") || "";
  return {
    first_name: first_name,
    family_name: family_name
  };
};
var TamaraInfoComponent = function TamaraInfoComponent(_ref) {
  var setIsOtpStep = _ref.setIsOtpStep,
    autosend = _ref.autosend,
    onFormUpdated = _ref.onFormUpdated,
    onFormCompleted = _ref.onFormCompleted;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useSession = useSession(),
    user = _useSession.user;
  var _useAuthActions = useAuthActions(),
    logout = _useAuthActions.logout;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTamaraFinance = useTamaraFinance(),
    tamaraActions = _useTamaraFinance.actions;
  var _useTamaraFinance$sta = useTamaraFinance().state,
    contextUserInfo = _useTamaraFinance$sta.userInfo,
    orderData = _useTamaraFinance$sta.orderData,
    checkoutOrderV2 = _useTamaraFinance$sta.checkoutOrderV2;
  var isMobile = useIsMobile();
  var _useState = useState(false),
    showVerificationModal = _useState[0],
    setShowVerificationModal = _useState[1];
  var _useApi = useApi([], api__getCitiesDropDown),
    _useApi2 = _slicedToArray(_useApi, 3),
    loadingCities = _useApi2[0],
    error = _useApi2[1],
    cities = _useApi2[2];
  var _useState2 = useState({}),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState(false),
    isSubmitting = _useState3[0],
    setIsSubmitting = _useState3[1];
  var post_id = useTamaraFinance().queryParams.post_id;
  var hasSyncedRef = useRef(false);
  var lang = useLang();

  // Use context data if available, otherwise use session data
  var userNames = extractUserNames(user);
  var _useState4 = useState({
      first_name: (contextUserInfo === null || contextUserInfo === void 0 ? void 0 : contextUserInfo.first_name) || userNames.first_name,
      family_name: (contextUserInfo === null || contextUserInfo === void 0 ? void 0 : contextUserInfo.family_name) || userNames.family_name,
      mobile_number: (user === null || user === void 0 ? void 0 : user.phone_number) || (contextUserInfo === null || contextUserInfo === void 0 ? void 0 : contextUserInfo.mobile_number) || "",
      city_id: String((contextUserInfo === null || contextUserInfo === void 0 ? void 0 : contextUserInfo.city_id) || "1"),
      whatsapp_optin: Number((contextUserInfo === null || contextUserInfo === void 0 ? void 0 : contextUserInfo.whatsapp_optin) || 1)
    }),
    userInfo = _useState4[0],
    setUserInfo = _useState4[1];

  // Sync component state with context data only ONCE when context loads from localStorage
  // This prevents overwriting user edits when context changes
  useEffect(function () {
    if (contextUserInfo && !hasSyncedRef.current) {
      setUserInfo(function (prevUserInfo) {
        var _contextUserInfo$what;
        return {
          first_name: contextUserInfo.first_name || prevUserInfo.first_name,
          family_name: contextUserInfo.family_name || prevUserInfo.family_name,
          mobile_number: contextUserInfo.mobile_number || prevUserInfo.mobile_number,
          city_id: String(contextUserInfo.city_id || prevUserInfo.city_id || "1"),
          whatsapp_optin: Number((_contextUserInfo$what = contextUserInfo.whatsapp_optin) !== null && _contextUserInfo$what !== void 0 ? _contextUserInfo$what : prevUserInfo.whatsapp_optin)
        };
      });
      hasSyncedRef.current = true;
    }
  }, [contextUserInfo]);
  useEffect(function () {
    if (user !== null && user !== void 0 && user.id && autosend && !isSubmitting) {
      var hasCompleteUserInfo = userInfo.first_name && userInfo.family_name && userInfo.mobile_number && userInfo.city_id;
      if (hasCompleteUserInfo) {
        sendData();
      }
    }
  }, [autosend]);
  var updateErrors = function updateErrors(key, value) {
    setErrors(function (prevData) {
      return _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
    });
  };
  var updateData = function updateData(key, value) {
    setUserInfo(function (prevData) {
      var newData = _objectSpread(_objectSpread({}, prevData), {}, _defineProperty({}, key, value));
      onFormUpdated === null || onFormUpdated === void 0 ? void 0 : onFormUpdated(true);
      tamaraActions === null || tamaraActions === void 0 ? void 0 : tamaraActions.action__updateUserInfo(_defineProperty({}, key, value));
      return newData;
    });
  };
  var validate = function validate() {
    var isValid = true;
    var newErrors = {};

    // Validate first_name with Arabic/English letters and spaces only
    if (!userInfo["first_name"] || userInfo["first_name"].trim() === "") {
      newErrors["first_name"] = tShort("tamara/first_name_required");
      isValid = false;
    } else if (userInfo["first_name"].trim().length < 2) {
      newErrors["first_name"] = tShort("tamara/first_name_min_length");
      isValid = false;
    } else if (userInfo["first_name"].trim().length > 50) {
      newErrors["first_name"] = tShort("tamara/first_name_max_length");
      isValid = false;
    } else if (!/^[\u0600-\u06FFa-zA-Z\s]+$/.test(userInfo["first_name"].trim())) {
      newErrors["first_name"] = tShort("tamara/first_name_invalid_chars");
      isValid = false;
    }

    // Validate family_name with Arabic/English letters and spaces only
    if (!userInfo["family_name"] || userInfo["family_name"].trim() === "") {
      newErrors["family_name"] = tShort("tamara/family_name_required");
      isValid = false;
    } else if (userInfo["family_name"].trim().length < 2) {
      newErrors["family_name"] = tShort("tamara/family_name_min_length");
      isValid = false;
    } else if (userInfo["family_name"].trim().length > 50) {
      newErrors["family_name"] = tShort("tamara/family_name_max_length");
      isValid = false;
    } else if (!/^[\u0600-\u06FFa-zA-Z\s]+$/.test(userInfo["family_name"].trim())) {
      newErrors["family_name"] = tShort("tamara/family_name_invalid_chars");
      isValid = false;
    }

    // Validate mobile_number
    if (!userInfo["mobile_number"] || userInfo["mobile_number"].trim() === "") {
      newErrors["mobile_number"] = tShort("tamara/mobile_required");
      isValid = false;
    } else if (!/^05\d{8}$/.test(userInfo["mobile_number"])) {
      newErrors["mobile_number"] = tShort("tamara/mobile_invalid_format");
      isValid = false;
    }

    // Validate city_id
    if (!userInfo["city_id"]) {
      newErrors["city_id"] = tShort("tamara/city_required");
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };
  var sendData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _checkoutOrderV2$sect, _checkoutOrderV2$sect2, _checkoutOrderV2$sect3, _checkoutOrderV2$sect4, _checkoutOrderV2$sect5, _response$data, searchParams, experiment_variant, tamaraRequest, response, _response$data2, _response$data3, _checkoutOrderV2$g4_d, _checkoutOrderV2$g4_d2, _checkoutOrderV2$g4_d3, _checkoutOrderV2$g4_d4, _checkoutOrderV2$g4_d5, _checkoutOrderV2$g4_d6, _checkoutOrderV2$g4_d7, _checkoutOrderV2$g4_d8, _checkoutOrderV2$g4_d9, _checkoutOrderV2$g4_d0, _checkoutOrderV2$g4_d1, _checkoutOrderV2$g4_d10, _checkoutOrderV2$g4_d11, _checkoutOrderV2$g4_d12, _checkoutOrderV2$deta, _error$response, apiToFormFieldMap, _errorData$status, _errorData$status2, _errorData$status3, errorData, firstError, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (validate()) {
              _context.n = 1;
              break;
            }
            toast.error(tShort("tamara/validation_error"));
            return _context.a(2);
          case 1:
            if (user !== null && user !== void 0 && user.id) {
              _context.n = 2;
              break;
            }
            tamaraActions === null || tamaraActions === void 0 ? void 0 : tamaraActions.action__updateUserInfo({
              first_name: userInfo.first_name,
              family_name: userInfo.family_name,
              mobile_number: userInfo.mobile_number,
              city_id: userInfo.city_id,
              whatsapp_optin: userInfo.whatsapp_optin
            });
            onFormCompleted === null || onFormCompleted === void 0 ? void 0 : onFormCompleted();
            setIsOtpStep(true);
            return _context.a(2);
          case 2:
            if (!(!autosend && userInfo["mobile_number"] != null && user !== null && user !== void 0 && user.phone_number && (user === null || user === void 0 ? void 0 : user.phone_number) != userInfo["mobile_number"] && !showVerificationModal)) {
              _context.n = 3;
              break;
            }
            return _context.a(2, setShowVerificationModal(true));
          case 3:
            if (post_id) {
              _context.n = 4;
              break;
            }
            toast.error(tShort("tamara/car_id_missing"));
            return _context.a(2);
          case 4:
            setIsSubmitting(true);
            _context.p = 5;
            searchParams = new URLSearchParams(__IS_CSR__ ? window.location.search : "");
            experiment_variant = searchParams.get("experiment_variant"); // Prepare Tamara checkout request
            tamaraRequest = _objectSpread({
              post_id: post_id,
              first_name: userInfo.first_name.trim(),
              last_name: userInfo.family_name.trim(),
              phone_number: userInfo.mobile_number,
              city_id: parseInt(userInfo.city_id),
              whatsapp_optin: userInfo.whatsapp_optin,
              success_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tamara/payment-success?post_id=").concat(post_id, "&experiment_variant=").concat(experiment_variant || ""),
              failure_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tamara/payment-failed?post_id=").concat(post_id, "&experiment_variant=").concat(experiment_variant || ""),
              cancel_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tamara/payment-cancel?post_id=").concat(post_id, "&experiment_variant=").concat(experiment_variant || "")
            }, (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$sect = checkoutOrderV2.sections) === null || _checkoutOrderV2$sect === void 0 ? void 0 : (_checkoutOrderV2$sect2 = _checkoutOrderV2$sect.find(function (s) {
              return s.type === 'warranty_list';
            })) === null || _checkoutOrderV2$sect2 === void 0 ? void 0 : (_checkoutOrderV2$sect3 = _checkoutOrderV2$sect2.items) === null || _checkoutOrderV2$sect3 === void 0 ? void 0 : (_checkoutOrderV2$sect4 = _checkoutOrderV2$sect3[0]) === null || _checkoutOrderV2$sect4 === void 0 ? void 0 : (_checkoutOrderV2$sect5 = _checkoutOrderV2$sect4.selected) === null || _checkoutOrderV2$sect5 === void 0 ? void 0 : _checkoutOrderV2$sect5.id) != null && {
              warranty_id: checkoutOrderV2.sections.find(function (s) {
                return s.type === 'warranty_list';
              }).items[0].selected.id
            }); // Call Tamara API
            _context.n = 6;
            return api__createTamaraCheckoutSession(tamaraRequest);
          case 6:
            response = _context.v;
            if (response.success && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.checkout_url) {
              tamaraActions === null || tamaraActions === void 0 ? void 0 : tamaraActions.action__updateUserInfo({
                first_name: userInfo.first_name,
                family_name: userInfo.family_name,
                mobile_number: userInfo.mobile_number,
                city_id: userInfo.city_id,
                whatsapp_optin: userInfo.whatsapp_optin,
                order_id: String(((_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.order_id) || "")
              });
              trackEvents("tamara_form_submit", {
                post_id: post_id,
                order_id: String(((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.order_id) || ""),
                user_city: String(userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id),
                inventory_type: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d === void 0 ? void 0 : (_checkoutOrderV2$g4_d2 = _checkoutOrderV2$g4_d.g4_data_layer) === null || _checkoutOrderV2$g4_d2 === void 0 ? void 0 : _checkoutOrderV2$g4_d2.inventory_type,
                post_make: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d3 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d3 === void 0 ? void 0 : (_checkoutOrderV2$g4_d4 = _checkoutOrderV2$g4_d3.g4_data_layer) === null || _checkoutOrderV2$g4_d4 === void 0 ? void 0 : _checkoutOrderV2$g4_d4.post_make,
                post_model: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d5 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d5 === void 0 ? void 0 : (_checkoutOrderV2$g4_d6 = _checkoutOrderV2$g4_d5.g4_data_layer) === null || _checkoutOrderV2$g4_d6 === void 0 ? void 0 : _checkoutOrderV2$g4_d6.post_model,
                post_trim: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d7 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d7 === void 0 ? void 0 : (_checkoutOrderV2$g4_d8 = _checkoutOrderV2$g4_d7.g4_data_layer) === null || _checkoutOrderV2$g4_d8 === void 0 ? void 0 : _checkoutOrderV2$g4_d8.post_ext,
                post_year: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d9 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d9 === void 0 ? void 0 : (_checkoutOrderV2$g4_d0 = _checkoutOrderV2$g4_d9.g4_data_layer) === null || _checkoutOrderV2$g4_d0 === void 0 ? void 0 : _checkoutOrderV2$g4_d0.post_year,
                post_condition: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d1 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d1 === void 0 ? void 0 : (_checkoutOrderV2$g4_d10 = _checkoutOrderV2$g4_d1.g4_data_layer) === null || _checkoutOrderV2$g4_d10 === void 0 ? void 0 : _checkoutOrderV2$g4_d10.post_condition,
                post_price: checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d11 = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d11 === void 0 ? void 0 : (_checkoutOrderV2$g4_d12 = _checkoutOrderV2$g4_d11.g4_data_layer) === null || _checkoutOrderV2$g4_d12 === void 0 ? void 0 : _checkoutOrderV2$g4_d12.post_price,
                total_amount: checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$deta = checkoutOrderV2.detail) !== null && _checkoutOrderV2$deta !== void 0 && _checkoutOrderV2$deta.total_amount ? parseFloat(String(checkoutOrderV2.detail.total_amount).replace(/,/g, "")) : undefined,
                platform: getPlatformInfo(),
                referral_location: "pre-checkout",
                experiment_variant: experiment_variant
              });
              onFormCompleted === null || onFormCompleted === void 0 ? void 0 : onFormCompleted();
              // Redirect to Tamara checkout
              window.location.href = response.data.checkout_url;
            } else {
              toast.error(tShort("tamara/payment_session_error"));
            }
            _context.n = 12;
            break;
          case 7:
            _context.p = 7;
            _t = _context.v;
            console.error("Error creating Tamara checkout:", _t);

            // Handle reserve and paid errors first (these take priority)
            if (!(_t instanceof PostReservedError)) {
              _context.n = 8;
              break;
            }
            toast.error(t("car_currently_reserved", {
              ns: "web_checkout_cash"
            }));
            // Redirect to car detail page after a brief delay
            setTimeout(function () {
              navigateTo("/cardetail/".concat(post_id));
            }, 2000);
            return _context.a(2);
          case 8:
            if (!(_t instanceof OrderPaidError)) {
              _context.n = 9;
              break;
            }
            toast.error(t("order_prepaid", {
              ns: "web_checkout_cash"
            }));
            // Redirect to tracking page after a brief delay
            setTimeout(function () {
              navigateTo("/tracking");
            }, 2000);
            return _context.a(2);
          case 9:
            if (!(_t instanceof ValidationException)) {
              _context.n = 10;
              break;
            }
            toast.error(_t.message);
            return _context.a(2);
          case 10:
            if (!(_t instanceof TamaraValidationError)) {
              _context.n = 11;
              break;
            }
            apiToFormFieldMap = {
              first_name: "first_name",
              last_name: "family_name",
              phone_number: "mobile_number",
              city_id: "city_id",
              whatsapp_optin: "whatsapp_optin"
            };
            _t.validationErrors.forEach(function (errorObj) {
              Object.entries(errorObj).forEach(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                  key = _ref4[0],
                  message = _ref4[1];
                var formField = apiToFormFieldMap[key];
                if (formField) {
                  updateErrors(formField, message);
                } else {
                  toast.error(message);
                }
              });
            });
            return _context.a(2);
          case 11:
            // Handle other specific error responses
            if (_t !== null && _t !== void 0 && (_error$response = _t.response) !== null && _error$response !== void 0 && _error$response.data) {
              errorData = _t.response.data;
              if (((_errorData$status = errorData.status) === null || _errorData$status === void 0 ? void 0 : _errorData$status.code) === 1004) {
                toast.error(tShort("tamara/car_not_eligible"));
              } else if (((_errorData$status2 = errorData.status) === null || _errorData$status2 === void 0 ? void 0 : _errorData$status2.code) === 401) {
                toast.error(tShort("tamara/please_login"));
              } else if (errorData.errors) {
                firstError = Object.values(errorData.errors)[0];
                if (typeof firstError === "string") {
                  toast.error(firstError);
                } else {
                  toast.error(tShort("tamara/check_data"));
                }
              } else if ((_errorData$status3 = errorData.status) !== null && _errorData$status3 !== void 0 && _errorData$status3.message) {
                toast.error(errorData.status.message);
              } else {
                toast.error(tShort("tamara/unexpected_error"));
              }
            } else {
              toast.error(tShort("tamara/connection_error"));
            }
          case 12:
            _context.p = 12;
            setIsSubmitting(false);
            return _context.f(12);
          case 13:
            return _context.a(2);
        }
      }, _callee, null, [[5, 7, 12, 13]]);
    }));
    return function sendData() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (loadingCities) return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center min-h-[600px]"
  }, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null));
  var requiredFields = ["first_name", "family_name", "mobile_number", "city_id"];
  var isButtonDisabled = false;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "tamara-form-container",
    className: "relative"
  }, /*#__PURE__*/React.createElement("div", {
    id: "tamara-form-inner",
    className: "".concat(isMobile ? "" : "")
  }, /*#__PURE__*/React.createElement("h1", {
    id: "tamara-form-title",
    className: "text-lg py-5 md-py-6 md:text-xl font-bold"
  }, tShort("tamara/form_title")), /*#__PURE__*/React.createElement(Input, {
    id: "checkout-firstname-input",
    className: "mb-[34px]",
    name: "first_name",
    label: t("first_name", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.first_name : "",
    onChange: function onChange(event) {
      var value = event.currentTarget.value;
      updateData("first_name", value);
      // Real-time validation for special characters
      if (value && !/^[\u0600-\u06FFa-zA-Z\s]*$/.test(value)) {
        updateErrors("first_name", tShort("tamara/first_name_invalid_chars"));
      } else if (errors !== null && errors !== void 0 && errors.first_name) {
        updateErrors("first_name", "");
      }
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.first_name) && updateErrors("first_name", "");
    },
    onBlur: function onBlur(event) {
      var value = event.currentTarget.value;
      if (!value || value.trim() === "") {
        updateErrors("first_name", tShort("tamara/first_name_required"));
      } else if (value.trim().length < 2) {
        updateErrors("first_name", tShort("tamara/first_name_min_length"));
      } else if (!/^[\u0600-\u06FFa-zA-Z\s]+$/.test(value.trim())) {
        updateErrors("first_name", tShort("tamara/first_name_invalid_chars"));
      } else {
        updateErrors("first_name", "");
      }
    },
    value: userInfo === null || userInfo === void 0 ? void 0 : userInfo.first_name
  }), /*#__PURE__*/React.createElement(Input, {
    id: "checkout-lastname-input",
    className: "mb-[34px]",
    name: "family_name",
    label: t("last_name", {
      ns: "web_checkout_finance"
    }),
    type: "text",
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.family_name : "",
    onChange: function onChange(event) {
      var value = event.currentTarget.value;
      updateData("family_name", value);
      // Real-time validation for special characters
      if (value && !/^[\u0600-\u06FFa-zA-Z\s]*$/.test(value)) {
        updateErrors("family_name", tShort("tamara/family_name_invalid_chars"));
      } else if (errors !== null && errors !== void 0 && errors.family_name) {
        updateErrors("family_name", "");
      }
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.family_name) && updateErrors("family_name", "");
    },
    onBlur: function onBlur(event) {
      var value = event.currentTarget.value;
      if (!value || value.trim() === "") {
        updateErrors("family_name", tShort("tamara/family_name_required"));
      } else if (value.trim().length < 2) {
        updateErrors("family_name", tShort("tamara/family_name_min_length"));
      } else if (!/^[\u0600-\u06FFa-zA-Z\s]+$/.test(value.trim())) {
        updateErrors("family_name", tShort("tamara/family_name_invalid_chars"));
      } else {
        updateErrors("family_name", "");
      }
    },
    value: userInfo === null || userInfo === void 0 ? void 0 : userInfo.family_name
  }), /*#__PURE__*/React.createElement(InputPhoneNumber, {
    id: "checkout-phone-input",
    className: "mb-[34px]",
    defaultValue: userInfo["mobile_number"],
    onChange: function onChange(value) {
      updateData("mobile_number", value);
    },
    errorLabel: errors ? errors === null || errors === void 0 ? void 0 : errors.mobile_number : "",
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.mobile_number) && updateErrors("mobile_number", "");
    },
    onBlur: function onBlur() {
      var value = userInfo.mobile_number;
      if (!value || value.trim() === "") {
        updateErrors("mobile_number", tShort("tamara/mobile_required"));
      } else if (!/^05\d{8}$/.test(value)) {
        updateErrors("mobile_number", tShort("tamara/mobile_invalid_format"));
      } else {
        updateErrors("mobile_number", "");
      }
    }
  }), /*#__PURE__*/React.createElement("label", {
    id: "tamara-whatsapp-label",
    className: [stl.whtsFlx, "mb-[34px]"].join(" ")
  }, /*#__PURE__*/React.createElement("input", {
    id: "tamara-whatsapp-input",
    onChange: function onChange(_) {
      var new_value = userInfo["whatsapp_optin"] ? 0 : 1;
      updateData("whatsapp_optin", new_value);
    },
    defaultChecked: !!userInfo["whatsapp_optin"],
    type: "checkbox",
    name: "whatsapp_optin"
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.boxDummy
  }), /*#__PURE__*/React.createElement("img", {
    id: "tamara-whatsapp-icon",
    src: CDN_LINK + "/assets/images/wpImg.svg",
    alt: "whts",
    width: "24px",
    height: "24px"
  }), /*#__PURE__*/React.createElement("span", {
    id: "tamara-whatsapp-text"
  }, t("like_receive_updates_order_via", {
    ns: "web_checkout_finance"
  }))), /*#__PURE__*/React.createElement(Select, {
    id: "checkout-city-select",
    name: "city_id",
    topLabel: t("city", {
      ns: "web_checkout_finance"
    }),
    error: errors ? errors === null || errors === void 0 ? void 0 : errors.city_id : "",
    onChange: function onChange(event) {
      var value = event.currentTarget.value;
      updateData("city_id", value);
      if (value && errors !== null && errors !== void 0 && errors.city_id) {
        updateErrors("city_id", "");
      }
    },
    onFocus: function onFocus() {
      (errors === null || errors === void 0 ? void 0 : errors.city_id) && updateErrors("city_id", "");
    },
    onBlur: function onBlur() {
      var value = userInfo.city_id;
      if (!value) {
        updateErrors("city_id", tShort("tamara/city_required"));
      }
    }
  }, cities.map(function (city, idx) {
    return idx === 0 ? /*#__PURE__*/React.createElement("option", {
      disabled: true,
      selected: true,
      hidden: true,
      key: idx
    }, t("select", {
      ns: "web_checkout_finance"
    })) : /*#__PURE__*/React.createElement("option", {
      selected: userInfo["city_id"] == city.id,
      key: city.id,
      value: city.id
    }, city.name);
  }))), isMobile ? /*#__PURE__*/React.createElement("div", {
    id: "tamara-mobile-submit-wrapper",
    className: "fixed bottom-0 left-0 z-[1] flex justify-between items-center w-full bg-white px-4 pt-5 pb-7 text-lg "
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end w-full"
  }, /*#__PURE__*/React.createElement("button", {
    id: "checkout-submit-btn",
    className: "blueBtn py-3 px-3 w-full flex justify-between items-center rounded-sm",
    onClick: sendData,
    disabled: isButtonDisabled || isSubmitting
  }, /*#__PURE__*/React.createElement("strong", null, tShort("tamara/next")), /*#__PURE__*/React.createElement("span", {
    className: stl.mobileButtonArrow
  }), isSubmitting && /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true,
    className: stl.btnLoading
  })))) : /*#__PURE__*/React.createElement("div", {
    id: "tamara-desktop-submit-wrapper",
    className: stl.submitData
  }, /*#__PURE__*/React.createElement("button", {
    id: "checkout-submit-btn",
    className: "blueBtn",
    onClick: sendData,
    disabled: isButtonDisabled || isSubmitting
  }, /*#__PURE__*/React.createElement("strong", null, tShort("tamara/next")), /*#__PURE__*/React.createElement("span", null), isSubmitting && /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true,
    className: stl.btnLoading
  }))), /*#__PURE__*/React.createElement(ChangeAccountVerificationModal, {
    show: showVerificationModal,
    onClose: function onClose() {
      return setShowVerificationModal(false);
    },
    onSubmit: function onSubmit() {
      setShowVerificationModal(false);
      logout(null).then(function () {
        return setIsOtpStep(true);
      });
    },
    newPhoneNumber: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobile_number,
    loading: false
  })));
};
export default TamaraInfoComponent;